import React from 'react';
import '../styles/Header.css';

const ACADEMY_URL = process.env.REACT_APP_ACADEMY_URL || 'http://localhost:3003';

const Header = () => {
  return (
    <header className="practice-header">
      <nav className="practice-header-nav">
        <a
          href={ACADEMY_URL}
          className="practice-header-link"
        >
          Back to Academy Home Page
        </a>
      </nav>
    </header>
  );
};

export default Header;
